import { Collapsible, Item, lucideIcons, Image } from '@round/creatorbase-ui';
import cn from 'classnames';
import { ReactNode, useState } from 'react';

import { ProjectCampaignOptionGroup } from '../useProjectCampaignGroups';

import styles from './ProjectItem.module.css';

const { ChevronRightIcon } = lucideIcons;

type Props = {
    group: ProjectCampaignOptionGroup;
    children: ReactNode;
};

export const ProjectItem = ({ group, children }: Props) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const optionsCount = group.options.length;
    const showOptionsBadge = optionsCount > 0;

    return (
        <Collapsible open={isExpanded} onOpenChange={setIsExpanded}>
            <Item variant="default" size="sm" className={styles.itemRoot}>
                <Collapsible.Trigger asChild>
                    <button type="button" className={styles.trigger}>
                        <Item.Media variant="default" className={styles.media}>
                            <div className={styles.mediaInner}>
                                <Image src={group.image ?? ''} alt={group.label} className={styles.projectImage} />
                                {showOptionsBadge ? <span className={styles.optionsBadge}>{optionsCount}</span> : null}
                            </div>
                        </Item.Media>
                        <Item.Content className={styles.content}>
                            <Item.Title className={styles.title}>{group.label}</Item.Title>
                            {!!(group.brand || group.team) && (
                                <Item.Description className={styles.brandRow}>
                                    {group.brand ? <span>{group.brand.name}</span> : null}
                                    {group.brand && group.team ? <span aria-hidden>•</span> : null}
                                    {group.team ? <span>{group.team.name}</span> : null}
                                </Item.Description>
                            )}
                        </Item.Content>
                        <ChevronRightIcon
                            className={cn(styles.chevron, isExpanded && styles.chevronOpen)}
                            aria-hidden
                        />
                    </button>
                </Collapsible.Trigger>

                <Collapsible.Content className={styles.campaignList}>{children}</Collapsible.Content>
            </Item>
        </Collapsible>
    );
};

export default ProjectItem;
